/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum ERROR_REPORT_TYPE {
	APP = "applicationError",
	RESOURCE = "resourceError",
	BLUEPRINT = "blueprintError",
	MODULE = "moduleError",
	EXTENSION = "extensionError"
}

export interface IErrorReport {
	type: ERROR_REPORT_TYPE;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[K: string]: any;
}
